import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { UserSummary } from '~/models/administration/user';
import { SecurityService } from '~/services/security.service';
import { ThemeManagerService } from '~/services/theme-manager';
import { LayoutManagerService } from '../layout/layout-manager';

@Component({
    templateUrl: './chart-header.html',
    styleUrls: ['./chart-header.scss'],
    selector: 'asap-chart-header',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChartHeaderComponent {

  _theme: string;
  _active: boolean;
  _showData: Array<any> = [{ field: 'Show Top 10', value: 10 },
  { field: 'Show Top 20', value: 20 },
  { field: 'Show Top 30', value: 30 }];

  _isDialiog: boolean = false;
  _dialogComponentName: string;
  _dialogModel: any;

  @Input() currentChart: string;
  @Input() apexValue: any;
  @Input() templatesName: string[];
  @Input() headerTitle: string = 'Graphs';

  @Output() top: EventEmitter<number> = new EventEmitter();
  @Output() getCurrentChart: EventEmitter<string> = new EventEmitter();
  @Output() getSelectedTemplate: EventEmitter<string> = new EventEmitter();
  _currentUser: UserSummary;

  constructor(
    private _themeManager: ThemeManagerService,
    private _layoutManager: LayoutManagerService,
    private _securityService: SecurityService
  ) {
    this._currentUser = this._securityService.currentUser;
    this._themeManager.themeChange.subscribe((data) => {

      this._theme = data;
    });
  }

  _openSliderForm(): void {
    this._active = true;
    this._layoutManager.applyOverly();
  }

  _closeForm() {
    this._active = false;
    this._layoutManager.removeOverlay();
  }

  _showDataValueChange(event: any) {
    setTimeout(() => {

      this.top.emit(event.value);
      this.getCurrentChart.emit(this.currentChart);
    }, 200);
  }

  _selectGraphByTempalateName(event: string) {
    setTimeout(() => {
      this.getSelectedTemplate.emit(event);
    }, 200);
  }

}
